import React, {createContext, useContext, useEffect, useState} from 'react';
import {useWebsocket} from "../context/websocket.context";
import TaskService from "../services/task.service";
import ApproveTaskModal from "../components/ApproveTaskModal";


export const TaskApproveContext = createContext<any>({});

export const TaskApproveProvider: React.FC = ({children}: any) => {
    const [editTaskData, setEditTaskData] = useState(null);
    const [initiateCompleteData, setInitiateCompleteData] = useState<any>(null);
    const {connect, ws} = useWebsocket()



    const initiateCompleteTask = async (taskData: any) => {

        const newInitiateCompleteData =  await TaskService.initiateComplete(taskData?.id)

        setInitiateCompleteData(newInitiateCompleteData)

        connect(`${(import.meta.env.VITE_API_BASE_URL || "").replace("/api", "")}/wss/tasks/complete/${newInitiateCompleteData.session_token}`)
        setEditTaskData(taskData)
        // const updatedTask = await TaskService.update(taskData.id, buildTaskUpdatePayload(taskData, taskData.project_id, {}))
    }

    const completeTask = async () => {
        await TaskService.completeConfirm(initiateCompleteData?.session_token)
        setInitiateCompleteData(null)
    }

    useEffect(() => {
        if(!ws){
            return () => {};
        }

        ws.onmessage = (ev: any) => {
            // Some servers send text frames; others may send JSON strings.
            try {
                const msg = JSON.parse(ev.data);

                if((msg?.event === "task_completion_status") && (msg?.status === "approved")){
                    setInitiateCompleteData(null)
                    return;
                }
            } catch {
                // Non-JSON payloads
                console.warn('[ws] non-JSON message:', ev.data);
            }
        };
    }, [ws])


    return (
        <TaskApproveContext.Provider value={{ initiateCompleteTask }}>
            {children}
            {initiateCompleteData?.deep_link && (
                <ApproveTaskModal deepLink={initiateCompleteData?.deep_link} completeTask={completeTask}/>
            )}
        </TaskApproveContext.Provider>
    );
};


export const useTaskApprove = () => {
    const context = useContext(TaskApproveContext);
    if (context === undefined) {
        throw new Error('useTaskApprove must be used within a TaskApproveProvider');
    }
    return context;
};
